<template>
	<div class="item" v-bind:class="type">
		<img v-if="isImage && hasMedia" v-bind:src="url"/>
		<video v-else-if="!isImage && hasMedia" v-bind:src="url"/>
	</div>
</template>

<script>
	export default {
		name: "ShowEditItem",
		props: ['step', 'type'],
		data() {
			return {
				hasMedia: false,
				isImage: true,
				url: ''
			}
		},
		created() {
			if (this.type === 'wall') {
				this.hasMedia = (this.step.wall_slide);
				if (this.hasMedia) {
					if (this.step.wall_slide.media.mime.includes('video')) {
						this.isImage = false;
						this.url = process.env.VUE_APP_BASE_URL + this.step.wall_slide.media.url + '#t=5';
					} else {
						this.url = process.env.VUE_APP_BASE_URL + this.step.wall_slide.media.formats.thumbnail.url;
					}
				}
			} else {
				this.hasMedia = (this.step.model_slide);
				if (this.hasMedia) {
					if (this.step.model_slide.media.mime.includes('video')) {
						this.isImage = false;
						this.url = process.env.VUE_APP_BASE_URL + this.step.model_slide.media.url + '#t=5';
					} else {
						this.url = process.env.VUE_APP_BASE_URL + this.step.model_slide.media.formats.thumbnail.url;
					}
				}
			}
		}
	}
</script>

<style scoped>
	
	.item {
		background-color: #333;
	}

	img, video {
		height: 90px;
		width: 161px;
		object-fit: contain;
	}

	/*video {
		max-width: 100%;
		max-height: 100%;
	}*/
</style>